export default __webpack_public_path__ + "static/media/ENGLISH_LITERATURE.285bd3b3.svg";